// src/utils/propertySpecificFields.js

export const kSpecificFields = {
  'Residential Sale': {
    'default': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      { name: 'floors', label: 'Number of Floors', type: 'number', required: false },
      { name: 'parking', label: 'Parking Spaces', type: 'number', required: false },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold', 'Customary'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed Available',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
      { name: 'yearBuilt', label: 'Year Built', type: 'number', required: false },
    ],
    'Houses / Villas': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      { name: 'floors', label: 'Number of Floors', type: 'number', required: false },
      { name: 'parking', label: 'Parking Spaces', type: 'number', required: false },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold', 'Customary'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
      {
        name: 'garden',
        label: 'Garden / Compound',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'security',
        label: 'Security',
        type: 'select',
        options: ['Gated', 'Guarded', 'CCTV', 'None'],
        required: false,
      },
    ],
    'Apartments / Flats': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      { name: 'floor', label: 'Floor Number', type: 'number', required: false },
      { name: 'totalFloors', label: 'Total Floors in Building', type: 'number', required: false },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'lift',
        label: 'Elevator / Lift',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'parking',
        label: 'Parking',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
    ],
    'Mansions': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      { name: 'floors', label: 'Number of Floors', type: 'number', required: true },
      { name: 'parking', label: 'Parking Spaces', type: 'number', required: true },
      {
        name: 'pool',
        label: 'Swimming Pool',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'gym',
        label: 'Gym',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
    ],
  },
  'Residential Rentals': {
    'default': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: false },
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'paymentFrequency',
        label: 'Payment Frequency',
        type: 'select',
        options: ['Monthly', 'Quarterly', 'Annually'],
        required: true,
      },
      { name: 'deposit', label: 'Security Deposit (months)', type: 'number', required: false },
      { name: 'availableFrom', label: 'Available From', type: 'date', required: false },
    ],
    'Rooms / Self-Contained': [
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'paymentFrequency',
        label: 'Payment Frequency',
        type: 'select',
        options: ['Monthly', 'Quarterly', 'Annually'],
        required: true,
      },
      {
        name: 'waterIncluded',
        label: 'Water Included',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'electricityIncluded',
        label: 'Electricity Included',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Servant Quarters / Boys Quarters': [
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      {
        name: 'furnished',
        label: 'Furnished',
        type: 'select',
        options: ['Furnished', 'Unfurnished'],
        required: true,
      },
      {
        name: 'paymentFrequency',
        label: 'Payment Frequency',
        type: 'select',
        options: ['Monthly', 'Quarterly', 'Annually'],
        required: true,
      },
    ],
    'Student Housing / Hostels': [
      { name: 'bedrooms', label: 'Beds per Room', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      {
        name: 'gender',
        label: 'Gender',
        type: 'select',
        options: ['Mixed', 'Male Only', 'Female Only'],
        required: true,
      },
      {
        name: 'meals',
        label: 'Meals Included',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'paymentFrequency',
        label: 'Payment Frequency',
        type: 'select',
        options: ['Monthly', 'Per Semester', 'Annually'],
        required: true,
      },
    ],
  },
  'Short Stay & Hospitality': {
    'default': [
      { name: 'rooms', label: 'Number of Rooms / Units', type: 'number', required: true },
      { name: 'capacity', label: 'Guest Capacity', type: 'number', required: true },
      { name: 'checkInTime', label: 'Check-In Time', type: 'text', required: false },
      { name: 'checkOutTime', label: 'Check-Out Time', type: 'text', required: false },
      {
        name: 'wifi',
        label: 'WiFi',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'breakfast',
        label: 'Breakfast Included',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'parking',
        label: 'Parking',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'pool',
        label: 'Swimming Pool',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Hotels': [
      {
        name: 'starRating',
        label: 'Star Rating',
        type: 'select',
        options: ['1 Star', '2 Stars', '3 Stars', '4 Stars', '5 Stars'],
        required: true,
      },
      { name: 'rooms', label: 'Number of Rooms', type: 'number', required: true },
      { name: 'capacity', label: 'Total Guest Capacity', type: 'number', required: true },
      {
        name: 'restaurant',
        label: 'Restaurant',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'pool',
        label: 'Swimming Pool',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'conferenceRoom',
        label: 'Conference Room',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'gym',
        label: 'Gym',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'wifi',
        label: 'WiFi',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Airbnb / Short-Let': [
      { name: 'bedrooms', label: 'Bedrooms', type: 'number', required: true },
      { name: 'bathrooms', label: 'Bathrooms', type: 'number', required: true },
      { name: 'capacity', label: 'Max Guests', type: 'number', required: true },
      { name: 'minNights', label: 'Minimum Nights', type: 'number', required: false },
      {
        name: 'wifi',
        label: 'WiFi',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'selfCheckIn',
        label: 'Self Check-In',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'petFriendly',
        label: 'Pet Friendly',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
  },
  'Commercial': {
    'default': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      {
        name: 'purpose',
        label: 'Purpose',
        type: 'select',
        options: ['For Sale', 'For Rent'],
        required: true,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold'],
        required: false,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: false,
      },
    ],
    'Office Spaces': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      {
        name: 'purpose',
        label: 'Purpose',
        type: 'select',
        options: ['For Sale', 'For Rent'],
        required: true,
      },
      { name: 'floors', label: 'Number of Floors', type: 'number', required: false },
      {
        name: 'openPlan',
        label: 'Open Plan',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      { name: 'meetingRooms', label: 'Meeting Rooms', type: 'number', required: false },
      { name: 'parking', label: 'Parking Spaces', type: 'number', required: false },
      {
        name: 'lift',
        label: 'Elevator / Lift',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'generator',
        label: 'Backup Generator',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Retail / Shops': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      {
        name: 'purpose',
        label: 'Purpose',
        type: 'select',
        options: ['For Sale', 'For Rent'],
        required: true,
      },
      {
        name: 'frontage',
        label: 'Street Frontage',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'storage',
        label: 'Storage Room',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Warehouses / Godowns': [
      { name: 'size', label: 'Size (sqm)', type: 'number', required: true },
      {
        name: 'purpose',
        label: 'Purpose',
        type: 'select',
        options: ['For Sale', 'For Rent'],
        required: true,
      },
      { name: 'ceilingHeight', label: 'Ceiling Height (m)', type: 'number', required: false },
      {
        name: 'loadingDock',
        label: 'Loading Dock',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'power',
        label: 'Three-Phase Power',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
    ],
    'Mixed-Use Buildings': [
      { name: 'totalSize', label: 'Total Size (sqm)', type: 'number', required: true },
      { name: 'residentialUnits', label: 'Residential Units', type: 'number', required: false },
      { name: 'commercialUnits', label: 'Commercial Units', type: 'number', required: false },
      { name: 'floors', label: 'Number of Floors', type: 'number', required: true },
      {
        name: 'purpose',
        label: 'Purpose',
        type: 'select',
        options: ['For Sale', 'For Rent'],
        required: true,
      },
    ],
  },
  'Land': {
    'default': [
      { name: 'size', label: 'Size (acres)', type: 'number', required: true },
      {
        name: 'sizeUnit',
        label: 'Size Unit',
        type: 'select',
        options: ['Acres', 'Hectares', 'Square Meters', 'Decimals', 'Perches'],
        required: true,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold', 'Customary'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
      { name: 'soilType', label: 'Soil Type', type: 'text', required: false },
      {
        name: 'waterSource',
        label: 'Water Source',
        type: 'select',
        options: ['None', 'Borehole', 'River', 'Municipal'],
        required: false,
      },
      {
        name: 'electricity',
        label: 'Electricity',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'roadAccess',
        label: 'Road Access',
        type: 'select',
        options: ['Tarmac Road', 'Murram Road', 'Footpath', 'None'],
        required: false,
      },
    ],
    'Agricultural Land / Farms': [
      { name: 'size', label: 'Size (acres)', type: 'number', required: true },
      {
        name: 'sizeUnit',
        label: 'Size Unit',
        type: 'select',
        options: ['Acres', 'Hectares'],
        required: true,
      },
      {
        name: 'tenure',
        label: 'Land Tenure',
        type: 'select',
        options: ['Mailo', 'Freehold', 'Leasehold', 'Customary'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
      { name: 'currentCrop', label: 'Current Crop / Use', type: 'text', required: false },
      { name: 'soilType', label: 'Soil Type', type: 'text', required: false },
      {
        name: 'irrigation',
        label: 'Irrigation System',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'waterSource',
        label: 'Water Source',
        type: 'select',
        options: ['Borehole', 'River', 'Rain-fed', 'Municipal'],
        required: false,
      },
    ],
    'Mailo Land': [
      { name: 'size', label: 'Size', type: 'number', required: true },
      {
        name: 'sizeUnit',
        label: 'Size Unit',
        type: 'select',
        options: ['Acres', 'Decimals', 'Perches'],
        required: true,
      },
      {
        name: 'titleDeed',
        label: 'Title Deed',
        type: 'select',
        options: ['Yes', 'No', 'In Progress'],
        required: true,
      },
      {
        name: 'encumbrances',
        label: 'Encumbrances / Sitting Tenants',
        type: 'select',
        options: ['None', 'Some', 'Yes'],
        required: false,
      },
      {
        name: 'roadAccess',
        label: 'Road Access',
        type: 'select',
        options: ['Tarmac Road', 'Murram Road', 'Footpath', 'None'],
        required: false,
      },
    ],
  },
  'Off-Plan & New Developments': {
    'default': [
      { name: 'developer', label: 'Developer / Company', type: 'text', required: true },
      { name: 'completionDate', label: 'Expected Completion', type: 'text', required: true },
      { name: 'totalUnits', label: 'Total Units', type: 'number', required: false },
      { name: 'unitsAvailable', label: 'Units Available', type: 'number', required: false },
      {
        name: 'paymentPlan',
        label: 'Payment Plan',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      { name: 'depositPercent', label: 'Deposit Required (%)', type: 'number', required: false },
      { name: 'amenities', label: 'Amenities', type: 'text', required: false },
    ],
    'Gated Communities / Estates': [
      { name: 'developer', label: 'Developer / Company', type: 'text', required: true },
      { name: 'completionDate', label: 'Expected Completion', type: 'text', required: true },
      { name: 'totalPlots', label: 'Total Plots / Units', type: 'number', required: false },
      { name: 'plotSize', label: 'Plot Size (sqm)', type: 'number', required: false },
      {
        name: 'paymentPlan',
        label: 'Payment Plan Available',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'security',
        label: 'Security',
        type: 'select',
        options: ['24/7 Guard', 'CCTV', 'Electric Fence', 'Boom Gate', 'Multiple'],
        required: false,
      },
      {
        name: 'amenities',
        label: 'Amenities (e.g. pool, gym, playground)',
        type: 'text',
        required: false,
      },
    ],
  },
  'Other Services': {
    'default': [
      { name: 'serviceType', label: 'Service Type', type: 'text', required: true },
      { name: 'experience', label: 'Years of Experience', type: 'number', required: false },
      { name: 'licenseNumber', label: 'License / Registration No.', type: 'text', required: false },
      { name: 'availability', label: 'Availability', type: 'text', required: false },
    ],
    'Property Management': [
      { name: 'propertiesManaged', label: 'Properties Currently Managed', type: 'number', required: false },
      { name: 'managementFee', label: 'Management Fee (%)', type: 'number', required: false },
      { name: 'services', label: 'Services Offered', type: 'text', required: true },
      { name: 'licenseNumber', label: 'License / Registration No.', type: 'text', required: false },
    ],
    'Valuations': [
      {
        name: 'valuationType',
        label: 'Valuation Type',
        type: 'select',
        options: ['Residential', 'Commercial', 'Agricultural', 'Industrial'],
        required: true,
      },
      {
        name: 'certifiedValuer',
        label: 'Certified Valuer',
        type: 'select',
        options: ['Yes', 'No'],
        required: true,
      },
      { name: 'licenseNumber', label: 'License No.', type: 'text', required: false },
      { name: 'turnaround', label: 'Turnaround Time', type: 'text', required: false },
    ],
        'Cleaning Services': [
      {
        name: 'serviceType',
        label: 'Service Type',
        type: 'select',
        options: [
          'Residential Cleaning',
          'Commercial Cleaning',
          'Deep Cleaning',
          'Move-in / Move-out Cleaning',
          'Post-Construction Cleaning',
          'Carpet & Upholstery Cleaning',
          'Window Cleaning',
          'Fumigation / Pest Control',
        ],
        required: true,
      },
      {
        name: 'pricingModel',
        label: 'Pricing Model',
        type: 'select',
        options: ['Per Hour', 'Per Sqm', 'Flat Rate', 'Per Room'],
        required: false,
      },
      { name: 'teamSize', label: 'Team Size', type: 'number', required: false },
      {
        name: 'equipmentProvided',
        label: 'Equipment Provided',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'ecoFriendlyProducts',
        label: 'Eco-Friendly Products',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      {
        name: 'insuranceCoverage',
        label: 'Insurance Coverage',
        type: 'select',
        options: ['Yes', 'No'],
        required: false,
      },
      { name: 'yearsExperience', label: 'Years of Experience', type: 'number', required: false },
      { name: 'licenseNumber', label: 'License / Registration No.', type: 'text', required: false },
      { name: 'serviceArea', label: 'Service Area / Coverage', type: 'text', required: false },
      { name: 'availability', label: 'Availability', type: 'text', required: false },
    ],
    'Mortgage & Financing': [
      {
        name: 'lenderType',
        label: 'Lender Type',
        type: 'select',
        options: ['Bank', 'SACCO', 'Microfinance', 'Private Lender'],
        required: true,
      },
      { name: 'interestRate', label: 'Interest Rate (%)', type: 'number', required: false },
      { name: 'maxLoanAmount', label: 'Max Loan Amount (UGX)', type: 'number', required: false },
      { name: 'repaymentPeriod', label: 'Repayment Period (years)', type: 'number', required: false },
    ],
  },
};

export const getSpecificFields = (category, subcategory) => {
  if (!category) return [];
  const catFields = kSpecificFields[category];
  if (!catFields) return [];
  return catFields[subcategory] || catFields['default'] || [];
};

export const getFieldNames = (category, subcategory) => {
  const fields = getSpecificFields(category, subcategory);
  return fields.map(f => f.name);
};

export const getRequiredFields = (category, subcategory) => {
  const fields = getSpecificFields(category, subcategory);
  return fields.filter(f => f.required).map(f => f.name);
};

export const getFieldByType = (category, subcategory, type) => {
  const fields = getSpecificFields(category, subcategory);
  return fields.filter(f => f.type === type);
};

export const getSelectFields = (category, subcategory) => {
  return getFieldByType(category, subcategory, 'select');
};

export const getNumberFields = (category, subcategory) => {
  return getFieldByType(category, subcategory, 'number');
};

export const getTextFields = (category, subcategory) => {
  return getFieldByType(category, subcategory, 'text');
};

export const getDateFields = (category, subcategory) => {
  return getFieldByType(category, subcategory, 'date');
};

export const getFieldOptions = (category, subcategory, fieldName) => {
  const fields = getSpecificFields(category, subcategory);
  const field = fields.find(f => f.name === fieldName);
  return field?.options || [];
};

export const isFieldRequired = (category, subcategory, fieldName) => {
  const fields = getSpecificFields(category, subcategory);
  const field = fields.find(f => f.name === fieldName);
  return field?.required || false;
};

export const getFieldLabel = (category, subcategory, fieldName) => {
  const fields = getSpecificFields(category, subcategory);
  const field = fields.find(f => f.name === fieldName);
  return field?.label || fieldName;
};

export default {
  kSpecificFields,
  getSpecificFields,
  getFieldNames,
  getRequiredFields,
  getFieldByType,
  getSelectFields,
  getNumberFields,
  getTextFields,
  getDateFields,
  getFieldOptions,
  isFieldRequired,
  getFieldLabel,
};